import { ArrowLongRightIcon } from '@heroicons/react/24/solid';
import Link from 'next/link';
import React from 'react';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';

type InformationCardProps = {
  barColor: string;
  content: string;
  headline: string;
  linkText: string;
  linkUrl: string;
  className?: string;
};

const InformationCard = ({
  barColor,
  content,
  headline,
  linkText,
  linkUrl,
  className,
}: InformationCardProps) => (
  <Wrapper barColor={barColor} className={className}>
    <Headline>{headline}</Headline>
    <Content>{content}</Content>
    <Link href={linkUrl} passHref>
      <LinkContent>
        {linkText}
        <LinkArrowIcon height={20} />
      </LinkContent>
    </Link>
  </Wrapper>
);

const Wrapper = styled.div<{ barColor: string }>`
  background-color: white;
  padding: 18px 16px;
  max-width: 440px;
  border: 0 solid black;
  border-radius: 4px;
  border-top-width: 6px;
  border-top-color: ${({ barColor }) => barColor};
  display: flex;
  flex-direction: column;
`;

const Headline = styled.div`
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 10px;
`;

const Content = styled.p`
  justify-content: flex-start;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.grayLight3};
  font-weight: 400;
  line-height: 22px;
  max-width: 400px;
  margin-bottom: auto;
`;

const LinkContent = styled.a`
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  margin-top: 24px;
  cursor: pointer;

  ${down('md')} {
    margin-top: 20px;
  }
`;

const LinkArrowIcon = styled(ArrowLongRightIcon)`
  margin-left: 7.75px;

  ${down('xs')} {
    transform: rotate(-45deg);
    height: 18px;
  }
`;

export default InformationCard;
